var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("report-toolbar", {
                attrs: {
                  "reset-to-default-props": _vm.resetToDefaultProps,
                  "set-default-props": _vm.setDefaultProps,
                  "report-props": Object.assign({}, _vm.runningReport, {
                    disabled: _vm.v$.$invalid,
                  }),
                },
                on: {
                  "clear-selection": _vm.handleClearSelection,
                  "reset-to-default": _vm.handleResetToDefault,
                  "set-default": _vm.handleSetDefault,
                  "run-report": _vm.handleRunReport,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.loading
        ? _c("renewal-tracking-container-loader")
        : _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.level")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-level", {
                            attrs: { "selected-level": _vm.settings.level },
                            on: {
                              "update:selectedLevel": function ($event) {
                                return _vm.$set(_vm.settings, "level", $event)
                              },
                              "update:selected-level": function ($event) {
                                return _vm.$set(_vm.settings, "level", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.showAgentSelect
                        ? _c(
                            "b-col",
                            {
                              staticClass: "mb-3",
                              attrs: { cols: "12", sm: "6" },
                            },
                            [
                              _c(
                                "h6",
                                {
                                  staticClass:
                                    "bold mb-1 form-title font-sm text-capitalize",
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$tc("global.doorr.agent", 1)) +
                                      "\n            "
                                  ),
                                  _c("input-required-indicator"),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("agents-select", {
                                ref: "agentsSelect",
                                attrs: {
                                  id: "select-agents-reports",
                                  value: _vm.settings.agents,
                                  "default-value": _vm.settings.agents,
                                  "select-options": _vm.options,
                                  label: "",
                                  "has-checkboxes": "",
                                  "space-classes":
                                    "form-group-material form-group-material-no-label",
                                  "close-on-select-all": "",
                                },
                                on: { change: _vm.handleSelectAgentChange },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("application-reports.format")) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-format", {
                            attrs: {
                              "selected-format": _vm.settings.format,
                              action: _vm.action,
                            },
                            on: {
                              "update:selectedFormat": function ($event) {
                                return _vm.$set(_vm.settings, "format", $event)
                              },
                              "update:selected-format": function ($event) {
                                return _vm.$set(_vm.settings, "format", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.commissions.feeType"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: {
                                id: "select-fee-type-search",
                                "no-label": "",
                                label: _vm.$t("global.words.search").toString(),
                                "hidden-label": true,
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass:
                                  "search-input w-100 vsSelectedCheckboxes",
                                attrs: {
                                  id: "feeTypeSelect",
                                  options: _vm.dropdownOptions.feeType,
                                  placeholder: _vm
                                    .$t("global.actions.chooseOption")
                                    .toString(),
                                  label: "text",
                                  clearable: "",
                                  "default-value": _vm.settings.feeType,
                                  multiple: "",
                                  "has-checkboxes": "",
                                  "deselect-from-dropdown": "",
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected": _vm.handleChangeFeeType,
                                  "option:deselected": _vm.handleChangeFeeType,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applicationStatus"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("select-application-status", {
                            ref: "applicationStatusSelect",
                            attrs: {
                              "selected-application-status":
                                _vm.settings.applicationStatus,
                              action: _vm.action,
                              clearable: false,
                              multiple: "",
                              "status-to-exclude": _vm.statusToExclude,
                            },
                            on: {
                              "update:selectedApplicationStatus": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.settings,
                                  "applicationStatus",
                                  $event
                                )
                              },
                              "update:selected-application-status": function (
                                $event
                              ) {
                                return _vm.$set(
                                  _vm.settings,
                                  "applicationStatus",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", sm: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.commissions.deductionType"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: {
                                id: "select-deduction-type-search",
                                "no-label": "",
                                label: _vm.$t("global.words.search").toString(),
                                "hidden-label": true,
                              },
                            },
                            [
                              _c("v-select-field", {
                                ref: "deductionTypeSelect",
                                staticClass:
                                  "search-input w-100 vsSelectedCheckboxes",
                                attrs: {
                                  options: _vm.dropdownOptions.deductionType,
                                  placeholder: _vm
                                    .$t("global.actions.chooseOption")
                                    .toString(),
                                  label: "text",
                                  clearable: "",
                                  "default-value": _vm.settings.deductionType,
                                  multiple: "",
                                  "has-checkboxes": "",
                                  "deselect-from-dropdown": "",
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected":
                                    _vm.handleChangeDeductionType,
                                  "option:deselected":
                                    _vm.handleChangeDeductionType,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6", sm: "6", lg: "6" } },
                        [
                          _c("h6", { staticClass: "form-title font-sm mb-0" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "application-reports.commissions.cashflow"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { "no-label": "" },
                              model: {
                                value: _vm.settings.cashflow,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settings, "cashflow", $$v)
                                },
                                expression: "settings.cashflow",
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.dropdownOptions.cashflow,
                                  value: _vm.settings.cashflow,
                                  clearable: false,
                                  label: "text",
                                  scenario: "reports",
                                  "default-value": _vm.settings.cashflow,
                                  multiple: false,
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected": _vm.handleChangeCashflow,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applications-summary.dateType"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { id: "select-date-type", "no-label": "" },
                              model: {
                                value: _vm.settings.dateType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settings, "dateType", $$v)
                                },
                                expression: "settings.dateType",
                              },
                            },
                            [
                              _c("v-select-field", {
                                key: JSON.stringify(
                                  _vm.dropdownOptions.dateType
                                ),
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.filteredDateType,
                                  placeholder: _vm
                                    .$t("global.actions.chooseOption")
                                    .toString(),
                                  value: _vm.settings.dateType,
                                  clearable: false,
                                  label: "text",
                                  scenario: "reports",
                                  "default-value": _vm.settings.dateType,
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected": function ($event) {
                                    _vm.settings.dateType = $event.id
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.dateFrom"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "application-summary-date-from",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "max-date": _vm.settings.dateTo,
                                        },
                                        model: {
                                          value: _vm.settings.dateFrom,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "dateFrom",
                                              $$v
                                            )
                                          },
                                          expression: "settings.dateFrom",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("application-reports.dateTo")
                                          ) +
                                          "\n                "
                                      ),
                                      _c("input-required-indicator"),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "field",
                                    [
                                      _c("date-section", {
                                        attrs: {
                                          id: "commissions-date-to",
                                          "maturity-date": "",
                                          placeholder: "YYYY-MM-DD",
                                          "min-date": _vm.settings.dateFrom,
                                        },
                                        model: {
                                          value: _vm.settings.dateTo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings,
                                              "dateTo",
                                              $$v
                                            )
                                          },
                                          expression: "settings.dateTo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { staticClass: "mb-3", attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "h6",
                            { staticClass: "form-title font-sm mb-0" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "application-reports.applications-summary.groupBy"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("input-required-indicator"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "material-input",
                            {
                              staticClass: "no-border",
                              attrs: { id: "select-group-by", "no-label": "" },
                              model: {
                                value: _vm.settings.groupBy,
                                callback: function ($$v) {
                                  _vm.$set(_vm.settings, "groupBy", $$v)
                                },
                                expression: "settings.groupBy",
                              },
                            },
                            [
                              _c("v-select-field", {
                                staticClass: "search-input w-100 simple-dd",
                                attrs: {
                                  options: _vm.dropdownOptions.groupBy,
                                  placeholder: _vm
                                    .$t("global.actions.chooseOption")
                                    .toString(),
                                  value: _vm.settings.groupBy,
                                  clearable: false,
                                  label: "text",
                                  "default-value": _vm.settings.groupBy,
                                  action: _vm.action,
                                },
                                on: {
                                  "option:selected": function ($event) {
                                    _vm.settings.groupBy = $event.id
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", lg: "6" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { sm: "6", cols: "12" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.applications-summary.firstSortBy"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "material-input",
                                    {
                                      staticClass: "no-border",
                                      attrs: {
                                        id: "select-sort-by-1",
                                        "no-label": "",
                                      },
                                      model: {
                                        value: _vm.settings.sortByPrimary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.settings,
                                            "sortByPrimary",
                                            $$v
                                          )
                                        },
                                        expression: "settings.sortByPrimary",
                                      },
                                    },
                                    [
                                      _c("v-select-field", {
                                        staticClass:
                                          "search-input w-100 simple-dd",
                                        attrs: {
                                          options: _vm.primaryOptions,
                                          placeholder: _vm
                                            .$t("global.actions.chooseOption")
                                            .toString(),
                                          value: _vm.settings.sortByPrimary,
                                          clearable: false,
                                          label: "text",
                                          scenario: "reports",
                                          "default-value":
                                            _vm.settings.sortByPrimary,
                                          action: _vm.action,
                                        },
                                        on: {
                                          "option:selected": function ($event) {
                                            _vm.settings.sortByPrimary =
                                              $event.id
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                {
                                  staticClass: "mb-3",
                                  attrs: { sm: "6", cols: "12" },
                                },
                                [
                                  _c(
                                    "h6",
                                    { staticClass: "form-title font-sm mb-0" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "application-reports.applications-summary.secondSortBy"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "material-input",
                                    {
                                      staticClass: "no-border",
                                      attrs: {
                                        id: "select-sort-by-2",
                                        "no-label": "",
                                      },
                                      model: {
                                        value: _vm.settings.sortBySecondary,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.settings,
                                            "sortBySecondary",
                                            $$v
                                          )
                                        },
                                        expression: "settings.sortBySecondary",
                                      },
                                    },
                                    [
                                      _c("v-select-field", {
                                        staticClass:
                                          "search-input w-100 simple-dd",
                                        attrs: {
                                          options: _vm.secondaryOptions,
                                          placeholder: _vm
                                            .$t("global.actions.chooseOption")
                                            .toString(),
                                          value: _vm.settings.sortBySecondary,
                                          clearable: false,
                                          label: "text",
                                          scenario: "reports",
                                          "default-value":
                                            _vm.settings.sortBySecondary,
                                          action: _vm.action,
                                        },
                                        on: {
                                          "option:selected": function ($event) {
                                            _vm.settings.sortBySecondary =
                                              $event.id
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }